import React from "react";
import styled from "styled-components";
import {RedButton} from "./ButtonStyles";

const DeleteButtonFullText = ({setModalOpen}) => {
    return (
        <DeleteButton onClick={() => setModalOpen(true)} className={"delete-btn-full"}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="none"/>
                <path
                    d="M7.71429 17.3333C7.71429 18.25 8.35714 19 9.14286 19H14.8571C15.6429 19 16.2857 18.25 16.2857 17.3333V9C16.2857 8.08333 15.6429 7.33333 14.8571 7.33333H9.14286C8.35714 7.33333 7.71429 8.08333 7.71429 9V17.3333ZM9.85714 9H14.1429C14.5357 9 14.8571 9.375 14.8571 9.83333V16.5C14.8571 16.9583 14.5357 17.3333 14.1429 17.3333H9.85714C9.46429 17.3333 9.14286 16.9583 9.14286 16.5V9.83333C9.14286 9.375 9.46429 9 9.85714 9ZM14.5 4.83333L13.9929 4.24167C13.8643 4.09167 13.6786 4 13.4929 4H10.5071C10.3214 4 10.1357 4.09167 10.0071 4.24167L9.5 4.83333H7.71429C7.32143 4.83333 7 5.20833 7 5.66667C7 6.125 7.32143 6.5 7.71429 6.5H16.2857C16.6786 6.5 17 6.125 17 5.66667C17 5.20833 16.6786 4.83333 16.2857 4.83333H14.5Z"
                    fill="#FAFAFA"/>
            </svg>
            <p> Supprimer </p>
        </DeleteButton>
    )
}

const DeleteButton = styled(RedButton)`
  width: 12rem;
  height: 2rem;
  p {
    flex-grow: 0.8;
  }
`


export default DeleteButtonFullText;